import { client } from "api";
import { OrderSerial } from "models/OrderSerial";

export type EditOrderSerialRequest =
  // Optional for editing
  Partial<Pick<OrderSerial, "description">> &
    // Required for editing
    Pick<
      OrderSerial,
      | "id"
      | "serial"
      | "assetNo"
      | "ip"
      | "macAddressWired"
      | "macAddressWifi"
      | "ethernetPort"
      | "userName"
      | "password"
      | "theftMarking"
      | "other"
      | "firmware"
      | "doa"
    >;

export type EditOrderSerialResponse = OrderSerial;

export const editOrderSerial = (request: EditOrderSerialRequest) =>
  client.patch<EditOrderSerialResponse>(`/checklist/serial`, request).then((res) => res.data);
